import { Cookie } from '@vue-util/cookie';

// Fallback logic to check consent from tealium if OptanonConsent is missing for any reason
const checkTealiumConsent = () => {
  try {
    const tealiumConsentConfig = window.tealiumCmpIntegration;
    const tealiumConsent = tealiumConsentConfig?.cmpConvertResponseToGroupList?.(tealiumConsentConfig?.cmpFetchCurrentConsentDecision?.());

    if (!tealiumConsentConfig || !tealiumConsent) {
      return 'C0004:1';
    }

    return tealiumConsent.includes('C0004') ? 'C0004:1' : 'C0004:0';
  } catch {
    return 'C0004:1';
  }
};

const getConsentStatus = (optanonConsent = '') => {
  if (optanonConsent.includes('C0004')) return optanonConsent.includes('C0004:1');
  return true;
};

let consentLoadedHandler = null;

export const removeConsentListener = () => {
  if (consentLoadedHandler) {
    window.removeEventListener('consent_loaded', consentLoadedHandler);
    consentLoadedHandler = null;
  }
};

export default function getOptanonConsent() {
  return new Promise((resolve) => {
    const optanonConsent = Cookie.get('OptanonConsent');

    if (optanonConsent) {
      resolve(getConsentStatus(optanonConsent));
      return;
    }

    let isResolved = false;

    consentLoadedHandler = () => {
      if (isResolved) return;
      isResolved = true;
      consentLoadedHandler = null;
      resolve(getConsentStatus(checkTealiumConsent()));
    };

    window.addEventListener('consent_loaded', consentLoadedHandler, { once: true });

    // Fallback in case the event never fires
    setTimeout(() => {
      if (!isResolved) {
        isResolved = true;
        removeConsentListener();
        resolve(true); // Default to true if timeout
      }
    }, 10000);
  });
}
